import { Flex, Heading, Text } from 'ui'
import { useCompanyMembersContext } from '../context/CompanyMembersProvider'
import { Filter } from './Filter'

export const Header = () => {
  const {
    state: { isInCompanyGroup },
  } = useCompanyMembersContext()

  return (
    <Flex flexDirection="column" gap={2}>
      <Flex flexDirection="column" gap={0}>
        <Heading level={3}>Team Members</Heading>
        <Text color="lightText">
          {isInCompanyGroup
            ? 'Manage team members across all companies in this company group.'
            : 'Manage team members for this company.'}
        </Text>
      </Flex>
      <Filter />
    </Flex>
  )
}
